import React from 'react'
import { Checkbox, FormControlLabel, styled } from '@mui/material'
import { FormControlLabelProps } from '@mui/material/FormControlLabel'

// Create a styled version of FormControlLabel with reduced padding
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: 0, // Remove default margin
  '& .MuiFormControlLabel-label': {
    padding: theme.spacing(0.5), // Adjust this value to control label padding
    fontSize: '16px',
  },
}))

// Create a custom component that extends FormControlLabelProps
interface FormControlCheckboxProps extends Omit<FormControlLabelProps, 'control'> {
  checked: boolean
  onChange: (event: React.SyntheticEvent<Element, Event>, checked: boolean) => void
  checkboxProps?: Record<string, string | boolean>
}

const FormControlCheckbox: React.FC<FormControlCheckboxProps> = ({
  checked,
  onChange,
  checkboxProps = {},
  ...props
}) => {
  return (
    <StyledFormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} {...checkboxProps} />}
      {...props}
    />
  )
}

export default FormControlCheckbox
